export default "__VITE_ASSET__CIqFyhKH__"